<script>
import { defineComponent, computed, h } from 'vue';
import Cta from 'Atoms/cta';

export default defineComponent({
  name: 'CtaLink',
  components: { Cta },
  setup(props, { slots }) {
    const cssClass = computed(() => {
      const classes = ['cta-link'];

      if (props.isDark) {
        classes.push('cta-link__dark');
      }

      if (props.isHover) {
        classes.push('cta-link__hover');
      }

      return classes.join(' ');
    });

    return () => h(
        Cta,
        {
          ...props,
          baseClass: cssClass.value
        },
        slots
      );
  },
  props: {
    isDark: {
      type: Boolean,
      default: false,
    },
    isHover: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss">
.cta-link {
  color: $color-medium;
  text-decoration: underline;

  // Icon
  .ui-icon {
    height: april-rem(16);
    width: april-rem(16);

    &:first-child:not(:only-child) {
      margin-right: april-rem($spacing-s);
    }

    &:last-child:not(:only-child) {
      margin-left: april-rem($spacing-s);
    }
  }

  &:hover,
  &:focus,
  &.cta-link__hover {
    color: $color-dark;
  }

  &.variant-secondary {
    @include body-text-xs;
  }

  &.cta-link__dark {
    color: $color-white;

    &:hover,
    &:focus {
      color: $color-light;
    }
  }

  &.cta-link__in-text {
    display: inline;
  }
}
</style>
